import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const TYPE_META = {
  definition: { label: "Definition", chipClass: "hk-chip-accent" },
  question: { label: "Question", chipClass: "hk-chip-info" },
  answer: { label: "Question", chipClass: "hk-chip-info" },
};

export const QuestionCard = ({ item, index, testIdPrefix = "question" }) => {
  const [revealed, setRevealed] = useState(false);
  const meta = TYPE_META[item.type] || TYPE_META.question;

  return (
    <article
      className="hk-card p-5 hk-rise"
      style={{ animationDelay: `${Math.min(index, 12) * 30}ms` }}
      data-testid={`${testIdPrefix}-card-${index}`}
    >
      <div className="flex items-center justify-between gap-3 mb-3">
        <div className="flex items-center gap-2">
          <span
            className="font-mono"
            style={{ color: "#7A9BB5", fontSize: 12 }}
            data-testid={`${testIdPrefix}-index-${index}`}
          >
            {String(index + 1).padStart(2, "0")}
          </span>
          <span
            className={`hk-chip ${meta.chipClass}`}
            data-testid={`${testIdPrefix}-type-${index}`}
          >
            {meta.label}
          </span>
        </div>
        <button
          type="button"
          onClick={() => setRevealed((r) => !r)}
          className="hk-btn-ghost px-3 py-1 text-xs flex items-center gap-1.5"
          aria-pressed={revealed}
          data-testid={`${testIdPrefix}-toggle-${index}`}
        >
          {revealed ? <EyeOff size={12} /> : <Eye size={12} />}
          {revealed ? "Hide" : "Reveal"}
        </button>
      </div>

      <h3
        className="font-display"
        style={{
          color: "#E8F0F7",
          fontWeight: 700,
          fontSize: 22,
          lineHeight: 1.3,
        }}
        data-testid={`${testIdPrefix}-text-${index}`}
      >
        {item.question}
      </h3>

      <div
        className="mt-3 overflow-hidden transition-all"
        style={{
          maxHeight: revealed ? 600 : 0,
          opacity: revealed ? 1 : 0,
        }}
        aria-hidden={!revealed}
      >
        <div
          className="hk-divider mb-3"
          style={{
            background:
              "linear-gradient(90deg, transparent, rgba(0,191,165,0.35), transparent)",
          }}
        />
        <p
          style={{
            color: "#E8F0F7",
            fontSize: 15,
            lineHeight: 1.55,
            opacity: 0.92,
          }}
          data-testid={`${testIdPrefix}-answer-${index}`}
        >
          {item.answer}
        </p>
      </div>
    </article>
  );
};

export default QuestionCard;
